<template>
    <div class="container">
        <div class="card">
            <div class="card-header">{{ title }}</div>
            <div class="card-body">
                <form>
                    <div class="form-group row">
                        <label for="title" class="col-md-4 col-form-label text-md-right">Τίτλος *</label>
                        <div class="col-md-6">
                            <input type="text" id="edit-title" class="form-control" name="title"
                                   v-model="announcementData.anakoinwshLek" required="required">
                        </div>
                    </div>

                    <Editor :old-content="announcementData.content" @contentChanged="onEditorContentChange"/>
                    <UploadFile v-if="isAddNewAttachment" @fileUploaded="onFileUploaded"></UploadFile>

                    <div v-if="announcementData.attachments.length > 0" class="form-group row">
                        <div class="col-md-12 text-md-left">
                            <h5>Συνημμένα:</h5>
                        </div>
                        <div class="col-md-12 text-md-center">
                            <div class="btn-group" v-for="a in announcementData.attachments" :key="a.attachmentId">
                                <button type="button" class="btn btn-warning"
                                        v-on:click="downloadAttachment(a.attachmentId,a.attacmentName)">
                                    {{ a.attacmentName }}
                                </button>
                                <button type="button" class="btn btn-danger"
                                        v-on:click="deleteAttachmentLocal(a.attachmentId)">
                                    <font-awesome-icon :icon="['fas', 'trash']"/>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div v-if="showTeams">
                        <div class="form-group row">
                            <div class="col-md-4 col-form-label text-md-right">
                                <b-button v-b-modal.group-modal variant="outline-primary">
                                    Δημιουργία ομάδας
                                </b-button>
                            </div>
                            <div class="col-md-6">
                                <multiselect v-model="announcementData.groups" :options="availableTeams"
                                             :multiple="true"
                                             :close-on-select="false" :clear-on-select="false"
                                             :preserve-search="true" placeholder="Επιλέξτε Ομάδα" label="onoma"
                                             track-by="onoma" :preselect-first="false">
                                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span
                                        class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{
                                            values.length
                                        }} options selected</span></template>
                                </multiselect>
                            </div>
                        </div>
                        <br>

                        <b-modal id="group-modal" title="Δημιουργία ομάδας" size="xl">
                            <CreateTeam ref="teams" @save:success="successGroup"/>
                            <template #modal-footer>
                                <div class="w-100">
                                    <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="$bvModal.hide('group-modal')"
                                    >
                                        Κλείσιμο
                                    </b-button>

                                    <b-button
                                        variant="primary"
                                        size="sm"
                                        class="float-right"
                                        @click="createGroup"
                                    >
                                        Αποθήκευση
                                    </b-button>
                                </div>
                            </template>
                        </b-modal>
                    </div>
                </form>
            </div>
        </div>
        <Message v-if="msgVisible" :message="message" :msgClass="msgClass"></Message>
    </div>
</template>

<script>
import Editor from "./Editor";
import UploadFile from './UploadFile';
import Message from './Message';
import {Structs as structs, Structs} from '@/structs';
import CreateTeam from '@/components/teams/CreateTeam';

export default {
    name: "EditAnnouncement",
    event: ['save:error', 'save:success'],
    components: {
        Editor,
        UploadFile,
        Message,
        CreateTeam
    },
    props: {
        id: String,
        announcementData: structs.AnnouncementData(),
        title: String
    },
    data() {
        return {
            availableTeams: [],
            deleteAttachmentList: [],
            filebase64: '',
            message: '',
            msgClass: '',
            msgVisible: false,
        }
    },
    mounted() {
        if (this.$store.getters.userRole === "ROLE_MANAGER" || this.$store.getters.userRole === "ROLE_SXHMATISMOS") {
            this.fetchTeams();
        }
    },
    computed: {
        hasEditAccess: function () {
            return Number(this.$store.getters.meeResponsible) === Number(this.announcementData.moepKwd)
                || this.role === 'ROLE_ADMIN';
        },
        isAddNewAttachment: function () {
            return this.announcementData.attachments == null || this.$validator.isEmptyObject(this.announcementData.attachments);
        },
        role: function () {
            return this.$store.getters.userRole;
        },
        showTeams: function () {
            return this.$store.getters.userRole === "ROLE_MANAGER" || this.$store.getters.userRole === "ROLE_SXHMATISMOS" || this.$store.getters.userRole === "ROLE_ADMIN";
        }
    },
    methods: {
        fetchTeams: function () {
            let moepKwd = this.$store.getters.yphrKwd;
            this.$store.dispatch('loading');
            this.$http.get("/groups/" + moepKwd)
                .then((response) => {
                    let resp = response.data;
                    this.availableTeams = resp.responseData;
                })
                .catch((e) => console.error(e))
                .finally(() => this.$store.dispatch('stop_loading'));
        },
        setMsg(status, msg) {
            this.message = msg;
            this.msgClass = status;
            this.msgVisible = true;
        },
        onFileUploaded(value) {
            this.filebase64 = value;
        },
        save: function () {
            this.deleteAttachmentList.forEach(x => this.deleteAttachmentDb(x));

            let announcement = Structs.Announcement();
            this.edit = false;

            if (this.filebase64 !== '') {
                let fileonoma = $("#fileUpload").val();
                fileonoma = fileonoma.replace(/.*[/\\]/, '');
                if (fileonoma !== '') {
                    let attachment = Structs.Attachment();
                    attachment.attachmentName = this.$validator.stripTags(fileonoma);
                    attachment.attachmentData = this.filebase64;
                    announcement.attachments.push(attachment);
                }
            }
            announcement.anakoinwshLek = this.$validator.stripTags(this.announcementData.anakoinwshLek);

            if (!this.announcementData.content) {
                this.message = "Παρακαλώ εισάγετε κάποιο κείμενο στην ανακοίνωση.";
                this.msgClass = 'danger';
                this.msgVisible = true;
                return
            }

            this.announcementData.content = this.announcementData.content.replace("<script>", "");
            this.announcementData.content = this.announcementData.content.replace("<//script>", "");
            this.announcementData.content = this.announcementData.content.replaceAll("<img ", "<img class=announcement-img' ");
            announcement.content = btoa(unescape(encodeURIComponent(this.announcementData.content)));

            announcement.groups = this.announcementData.groups;

            this.$store.dispatch("loading");
            let ref = this;

            let url = this.id ? "/announcements/" + this.id : "/announcements";
            this.$http.post(url, announcement)
                .then((response) => {
                    let resp = response.data;
                    let msg = "";
                    switch (announcement.anakoinwshStatus) {
                        case "PENDING":
                            msg = 'Η δημιουργία της ανακοίνωσης πραγματοποιήθηκε με επιτυχία.\n Η ανακοίνωση έχει υποβληθεί στη Διεύθυνση Επιστρατεύσεως - Εθνοφυλακής για έγκριση.';
                            break;
                        case "PUBLISHED":
                            msg = 'Η δημοσίευση της ανακοίνωσης έγινε επιτυχώς.';
                            break;
                    }
                    this.setMsg('success', msg);
                    ref.$emit("save:success", resp.announcement.anakoinwshKwd);
                })
                .catch((e) => {
                    console.error(e)
                    let resp = e.response;
                    console.error((resp.data.errorMessage) ? resp.data.errorMessage : resp.statusText);
                    this.message = "Υπήρξε κάποιο πρόβλημα!"
                    this.msgClass = 'danger';
                    this.msgVisible = true;
                })
                .finally(() => this.$store.dispatch('stop_loading'));
        },

        downloadAttachment: function (attachmentID, attachmentName) {
            let url = "/announcements/download/" + attachmentID;
            this.$store.dispatch('loading');
            this.$http({
                url: url,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                // this.$store.commit('set_token', response.headers.jwt);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", attachmentName);
                this.$store.dispatch('stop_loading');
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            }).catch((e) => {
                console.error(e);
                this.$store.dispatch('stop_loading');
            });
        },

        deleteAttachmentLocal: function (attachmentID) {
            this.announcementData.attachments.forEach((attachment, index, attachments) => {
                if (attachment.attachmentId === attachmentID) {
                    attachments.splice(index, 1);
                }
            })
            this.deleteAttachmentList.push(attachmentID);
        },

        deleteAttachmentDb: function (attachmentID) {
            this.$store.dispatch('loading');
            this.$http.post("/announcements/attachments/delete/" + attachmentID)
                .then((response) => {
                    let resp = response.data;
                    this.setMsg('success', resp.message);
                })
                .catch((e) => console.error(e))
                .finally(() => this.$store.dispatch('stop_loading'))
        },
        onEditorContentChange(value) {
            this.announcementData.content = value;
        },
        createGroup() {
            this.$refs.teams.createGroup();
        },
        successGroup: function () {
            this.fetchTeams();
            this.$bvModal.hide('group-modal')
        },
    }
}
</script>

<style scoped>

.btn {
    margin-left: 10px;
}

ul.groupsList li {
    font-weight: 900;
    font-size: 1.1rem;
}

ul.groupsList li::before {
    content: "-";
}
</style>